<!--
 * @FileDescription: tablist
 * @Autor: liuwp
 * @Date: 2022-08-09 15:50:08
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-13 10:20:26
-->
<template>
  <section ref="tableList" class="yxtbiz-select-rank-table-list">
    <yxt-table
      ref="table"
      :data="tableData"
      :row-key="(row) => { return row.sourceId }"
      style="width: 100%;"
      height="100%">
      <!-- 榜单名称 -->
      <yxt-table-column
        prop="title"
        :label="$t('pc_biz_select_rank_title')"
        width="200">
      </yxt-table-column>
      <!-- 榜单内容 -->
      <yxt-table-column
        :label="$t('pc_biz_select_rank_content')"
        width="200">
        <template slot-scope="scope">
          {{ showName(scope.row) }}
        </template>
      </yxt-table-column>
      <!-- 范围 -->
      <yxt-table-column
        :label="$t('pc_biz_select_rank_range')"
        width="200">
        <template slot="header">
          <yxt-tooltip effect="dark" placement="top">
            <!-- 集团榜：将集团内的所有人员进行排行（注：若排行榜的范围设置了部门，则无法支持集团榜）
                平台榜：将机构内的人员进行排行 -->
              <template slot="content">
                <div class="pc-biz-select-rank-tooptip">
                  <p>{{ $t('pc_biz_select_rank_tooltip_tips') }}</p>
                  <p>{{ $t('pc_biz_select_rank_tooltip_tips_normal') }}</p>
                </div>
              </template>
            <yxt-svg style="vertical-align: text-bottom;" class='color-gray-6 hover-primary-6'  width="16px" height="16px" icon-class="icons/question-cirlce-o" />
          </yxt-tooltip>
        </template>
        <template slot-scope="scope">
          <div class="select-rank-tab-checkbox">
            <div v-if="scope.row.showGroupRankList" @click="checkBoxClick(!scope.row.groupChecked && selectedValue.length === maxLength)">
              <!-- 集团榜 -->
              <yxt-checkbox :disabled='!scope.row.groupChecked && selectedValue.length === maxLength' v-model='scope.row.groupChecked' @change="selectRow(scope.row, 'groupChecked', 'platformChecked')">{{ $t('pc_biz_select_rank_group') }}</yxt-checkbox>
            </div>
            <div @click="checkBoxClick(!scope.row.platformChecked && selectedValue.length === maxLength)">
              <!-- 平台榜 -->
              <yxt-checkbox :disabled='!scope.row.platformChecked && selectedValue.length === maxLength' v-model='scope.row.platformChecked' @change="selectRow(scope.row, 'platformChecked', 'groupChecked')">{{ $t('pc_biz_select_rank_platform') }}</yxt-checkbox>
            </div>
          </div>
        </template>
      </yxt-table-column>
    </yxt-table>
  </section>
</template>
<script>
export default {
  props: {
    selectedValue: {
      type: Array,
      default: []
    },
    maxLength: {
      type: Number
    },
    tableData: {
      type: Array,
      default: []
    }
  },
  watch: {
    selectedValue: {
      handler() {
        this.checkSelected();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    showName(row) {
      // 部门的 排行榜
      return `${row.scopes.find(item => item === 'deptScope') ? this.$t('pc_biz_select_rank_departmental') : ''}${row.objectName}${row.attributeName}${ this.$t('pc_biz_select_rank') }`;
    },
    checkSelected() {
      this.$nextTick(() => {
        this.tableData.forEach((item, index) => {
          let arr = this.selectedValue.filter(v => v.sourceId === item.sourceId);
          if (arr.length === 1) {
            this.$set(this.tableData, index, {
              ...item,
              groupChecked: arr[0].groupChecked,
              platformChecked: arr[0].platformChecked
            });
          } else if (arr.length === 2) {
            this.$set(this.tableData, index, {
              ...item,
              groupChecked: true,
              platformChecked: true
            });
          } else {
            this.$set(this.tableData, index, {
              ...item,
              groupChecked: false,
              platformChecked: false
            });
          }
        });
      });
    },
    checkBoxClick(type) {
      if (type) {
        this.$message({
          message: this.$t('pc_biz_select_rank_tips'), // '选择的榜单已达上限'
          type: 'warning'
        });
      }
    },
    selectRow(row, type, othertype) {
      let hasRow = this.selectedValue.find(item => item.sourceId === row.sourceId && item[type]);
      if (!hasRow) {
        if (this.selectedValue.length === this.maxLength) return;
        this.selectedValue.push({
          ...row,
          [type]: true,
          [othertype]: false
        });
        return;
      }
      this.$emit('selectedValue', this.selectedValue.splice(this.selectedValue.findIndex(item => item.sourceId === row.sourceId && item[type]), 1));
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-select-rank-table-list {
  width: 100%;
  flex: 1;
  overflow: hidden;
  // margin-bottom: 16px;
}
.select-rank-tab-checkbox {
  display: flex;
  .yxt-checkbox {
    margin-right: 16px;
  }
}
.pc-biz-select-rank-tooptip {
  font-size: 12px;
  p {
    margin: 0;
  }
}
</style>
